import React from "react";
import clsx from "clsx";
import { Box } from '@curves/ui-base';

const NOTIFY_TYPE_CLASS = {
	1: "analysis-result-box--normal",
	2: "analysis-result-box--take-careful",
	3: "analysis-result-box--high-risk",
};

const AnalysisResultBox = ({ className = "", Tip, Desc, notifyType }) => {
	const notifyClass = NOTIFY_TYPE_CLASS[notifyType] ?? NOTIFY_TYPE_CLASS[1];
	return (
		<Box className={"analysis-result-box-wrapper"}>
			<Box className={clsx("analysis-result-box", notifyClass, className)}>
				<Box className={"analysis-result-box__description"}>
					{Tip && <span className={"analysis-result-box__description-title analysis-result-box__description-title--main"}>{Tip}</span>}
					<span className={"analysis-result-box__description-text"}>{Desc}</span>
				</Box>
			</Box>
		</Box>
	);
};

export default AnalysisResultBox;
